<template>
  <div class="rounded-button-orange rounded-button-orange--filled" :class="{'rounded-button-orange__alma rounded-button-orange__alma--filled': isAlmaTerritory}" ref="splitButton">
  <button class="my-main-btn" :class="{ 'my-main-btn--alma': isAlmaTerritory }" :disabled="disabled" @click="handleMainClick">{{ translatedLabel }}</button>
  <button type="button" class="my-dropdown-toggle"  :class="{ 'my-dropdown-toggle--alma': isAlmaTerritory }" @click="toggleDropdown">▼</button>

  <transition name="fade-slide">
  <ul v-if="showDropdown" class="my-dropdown-menu">
    <li v-for="option in translatedOptions" :key="option.id" @click="selectOption(option)" :class="{ selected: currentSelection && currentSelection.id === option.id }">
      <span class="dot" />
      <span class="label">{{ option.label }}</span>
     </li>
  </ul>
  </transition>
</div>

</template>

<script>

/* eslint-disable */
import isAlmaTerritories from '@/modules/dashboard/components/mixins/isAlmaTerritories';


export default {
  name: 'SplitButton',
  mixins: [isAlmaTerritories],
  props: {
    labelKey: {
      type: String,
      default: 'dashboard.action.sendAndCreateTreatment'
    },
    actions: {
      type: Array,
      requiered: true
      // default: () => Object.values(ACTIONS)
    },
    mainEventName: {
      type: String,
      default: 'main-click'
   },
   disabled: {
    type: Boolean,
    default: false
  }
  },
  data() {
    return {
      showDropdown: false,
      selectedOption: null
    };
  },
  computed: {
    translatedOptions() {
      return this.actions.map(action => ({
        id: action.id,
        label: this.$t(action.labelKey)
      }));
    },
    currentSelection: {
      get() {
        return this.selectedOption || (this.translatedOptions.length ? this.translatedOptions[0] : null);
      },
      set(val) {
        this.selectedOption = val;
      }
    },
    translatedLabel() {
      return this.$t(this.labelKey);
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    if (!this.selectedOption && this.translatedOptions.length > 0) {
      const [firstOption] = this.translatedOptions;
      this.selectedOption = firstOption;
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleMainClick() {
      if (this.disabled) return;
      const actionId = this.currentSelection?.id;
      this.$emit(this.mainEventName, actionId);
      this.showDropdown = false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.$emit('option-selected', option);
      this.showDropdown = false;
    },
    handleClickOutside({ target }) {
      const { splitButton } = this.$refs;
      if (splitButton && !splitButton.contains(target)) {
        this.showDropdown = false;
      }
    }
  }
};
</script>

<style scoped>
/* --- Fade/slide transition --- */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.2s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* --- Split button wrapper --- */
.rounded-button-orange.rounded-button-orange--filled {
  display: inline-flex;
  align-items: stretch;
  padding: 0 !important;
  background: none !important;
  border-radius: 50px; /* 💡 makes the overall pill shape */
  position: relative;
  z-index: 100;
  overflow: visible !important;
}

/* --- Base buttons --- */
.my-main-btn,
.my-dropdown-toggle {
  padding: 8px 18px;
  cursor: pointer;
  border: none;
  font-weight: 500;
  color: #fff;
  font-size: 15px;
  line-height: 1.2;
  background-color: #ff6a00;
  transition: background-color 0.25s ease, color 0.25s ease;
}

.my-main-btn {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-right: 1px solid rgba(255,255,255,0.25);
}

.my-dropdown-toggle {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  width: 40px;
  text-align: center;
  padding: 8px 0;
  margin-left: -1px; /* hide seam at zoom */
}

/* --- Hover for both halves --- */
.rounded-button-orange.rounded-button-orange--filled:hover .my-main-btn,
.rounded-button-orange.rounded-button-orange--filled:hover .my-dropdown-toggle {
  background-color: #ff7c1a;
}

/* --- Dropdown menu --- */
.my-dropdown-menu {
  position: absolute;
  top: 100%;
  left: -15px;
  background: #fff;
  border: 1px solid #0b0505a7;
  border-radius: 12px; /* slightly rounded dropdown */
  list-style: none;
  padding: 4px 0;
  margin: 4px 0 0 0;
  z-index: 9999;
  width: max-content;
  white-space: nowrap;
  min-width: calc(100% + 20px);
}

/* --- Dropdown items --- */
.my-dropdown-menu li {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  gap: 6px;
  text-align: left;
  color: #333;
  transition: background 0.15s ease;
}

.my-dropdown-menu li:hover {
  background: #fece93;
}

/* --- Dot indicator --- */
.my-dropdown-menu li .dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  border: 1px solid #000;
  margin-right: 10px;
  background-color: transparent;
  transition: background 0.15s;
}

.my-dropdown-menu li.selected .dot {
  background-color: #000;
}

/* --- ALMA Theme (purple variant) --- */
.rounded-button-orange__alma.rounded-button-orange__alma--filled {
  background: none !important;
}

.rounded-button-orange__alma .my-main-btn,
.rounded-button-orange__alma .my-dropdown-toggle {
  background-color: #3e2d5b !important;
  color: #ffffff !important;
  border: none;
}

.rounded-button-orange__alma .my-main-btn {
  border-right: 1px solid rgba(255,255,255,0.2);
}

.rounded-button-orange__alma .my-dropdown-toggle {
  margin-left: -1px; /* hide zoom seam */
}

.rounded-button-orange__alma .my-main-btn:hover,
.rounded-button-orange__alma .my-dropdown-toggle:hover,
.rounded-button-orange__alma.rounded-button-orange__alma--filled:hover .my-main-btn,
.rounded-button-orange__alma.rounded-button-orange__alma--filled:hover .my-dropdown-toggle {
  background-color: #4b3770 !important;
}

/* --- Alma dropdown hover --- */
.rounded-button-orange__alma .my-dropdown-menu li:hover {
  background-color: #dcd1ee;
  color: #3e2d5b;
}

/* --- Responsive fix --- */
@media (max-width: 767px) {
  .my-dropdown-menu {
    bottom: 100%;
    top: auto !important;
    margin-bottom: 8px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
    left: -15px;
    min-width: calc(100% + 24px);
  }
}


</style>
